import styleInject from '../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".index-module_inlineIcon__fnGmL {\n  fill: none;\n}";
var styles = {"inlineIcon":"index-module_inlineIcon__fnGmL"};
styleInject(css_248z);

export { styles as default };
